'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var makeStyles = require('../../Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"]({
  hiddenAutofillInput: {
    position: 'absolute',
    left: 0,
    width: 0,
    height: 0,
    zIndex: '-1'
  }
});

var HiddenIgnoreAutofillInput = function HiddenIgnoreAutofillInput(_ref) {
  var type = _ref.type,
      props = objectWithoutProperties(_ref, ["type"]);

  var _useStyles = useStyles(),
      hiddenAutofillInput = _useStyles.hiddenAutofillInput;

  return React__default["default"].createElement("input", _extends["default"]({
    type: type,
    tabIndex: "-1",
    className: hiddenAutofillInput
  }, props));
};

module.exports = HiddenIgnoreAutofillInput;
